import { render, staticRenderFns } from "./EstimateClipboardPreliminaryGroups.vue?vue&type=template&id=226060f8&"
import script from "./EstimateClipboardPreliminaryGroups.vue?vue&type=script&lang=js&"
export * from "./EstimateClipboardPreliminaryGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports